var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000105"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.536 88C251.292 88 256 92.708 256 98.463v19.074c0 5.755-4.708 10.463-10.463 10.463h-19.073C220.71 128 216 123.292 216 117.537V98.463C216 92.708 220.71 88 226.464 88h19.072zm-5.321 7.567h-3.585l-.037 17.477c0 2.145-1.895 3.834-4.038 3.834-2.145 0-3.882-1.737-3.882-3.882 0-2.143 1.737-3.882 3.882-3.882.16 0 .313.029.47.048v-3.748c-.157-.01-.311-.025-.47-.025-4.2 0-7.607 3.406-7.607 7.607 0 4.2 3.406 7.605 7.607 7.605 4.2 0 7.605-3.404 7.605-7.605v-10.292c1.235 1.887 3.338 3.023 5.592 3.022.207 0 .412-.011.617-.03h.001v-4.167c-3.224-.235-5.816-2.746-6.155-5.962z",
    transform: "translate(-620 -2193) translate(404 2105)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.0c0dfd2a.svg";
export { ForwardRef as ReactComponent };